'use strict';

// http://assanka.net/content/tech/2009/09/02/json2-js-vs-prototype/

module.exports = function(object) {
  return JSON.stringify(object, function(key, value) {
    return (this[key] instanceof Array) ? this[key] : value;
  });
};



//////////////////
// WEBPACK FOOTER
// ./~/faye/src/util/to_json.js
// module id = 15
// module chunks = 0